(function () {
  'use strict';

  function boot() {
    var root = document.querySelector('[data-pg-post-order-upload]');
    if (!root || root.__pgV53Ready) return;
    root.__pgV53Ready = true;

    var endpoint = root.getAttribute('data-endpoint') || '';
    var maxPets = Math.max(1, Math.min(6, parseInt(root.getAttribute('data-max-pets') || '6', 10) || 6));
    var maxPerPet = 3;
    var maxBytes = 20 * 1024 * 1024;
    var allowedExt = /\.(jpe?g|png|webp|heic|heif)$/i;
    var form = root.querySelector('[data-upload-form]');
    var pills = root.querySelector('[data-pet-pills]');
    var petsWrap = root.querySelector('[data-pets]');
    var orderInput = root.querySelector('[data-order-number]');
    var emailInput = root.querySelector('[data-order-email]');
    var notesInput = root.querySelector('[data-notes]');
    var submit = root.querySelector('[data-submit]');
    var error = root.querySelector('[data-error]');
    var status = root.querySelector('[data-status]');
    var progressWrap = root.querySelector('[data-progress-wrap]');
    var progressBar = root.querySelector('[data-progress]');
    var success = root.querySelector('[data-success]');
    var formBody = root.querySelector('[data-form-body]');
    var petCount = 1;
    var filesByPet = {};
    var busy = false;

    if (!endpoint || !form || !pills || !petsWrap || !submit) return;

    function uuid() {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
      var bytes = new Uint8Array(16);
      if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
      else for (var i = 0; i < bytes.length; i++) bytes[i] = Math.floor(Math.random() * 256);
      bytes[6] = (bytes[6] & 15) | 64;
      bytes[8] = (bytes[8] & 63) | 128;
      var hex = Array.prototype.map.call(bytes, function (b) { return b.toString(16).padStart(2, '0'); }).join('');
      return hex.slice(0, 8) + '-' + hex.slice(8, 12) + '-' + hex.slice(12, 16) + '-' + hex.slice(16, 20) + '-' + hex.slice(20);
    }

    var submissionId = uuid();

    function setError(message) {
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
    }

    function setStatus(message) {
      if (!status) return;
      status.textContent = message || '';
      status.hidden = !message;
    }

    function setProgress(percent) {
      var pct = Math.max(0, Math.min(100, Math.round(percent || 0)));
      if (progressWrap) progressWrap.hidden = pct <= 0;
      if (progressBar) {
        progressBar.style.width = pct + '%';
        progressBar.setAttribute('aria-valuenow', String(pct));
      }
    }

    function setBusy(value, label) {
      busy = !!value;
      submit.disabled = busy;
      submit.setAttribute('aria-busy', busy ? 'true' : 'false');
      submit.classList.toggle('is-busy', busy);
      submit.innerHTML = busy
        ? '<span class="pgupl-v53__spinner" aria-hidden="true"></span><span>' + (label || 'UPLOADING...') + '</span>'
        : '<span>SEND MY PHOTO(S)</span>';
    }

    function fileValid(file) {
      if (!file || !file.size) return 'That file could not be read. Please choose it again.';
      if (file.size > maxBytes) return '“' + (file.name || 'That photo') + '” is over 20MB. Please choose a smaller image.';
      if (!allowedExt.test(file.name || '') && !/^image\/(jpeg|png|webp|heic|heif)$/i.test(file.type || '')) {
        return 'Please use a JPG, PNG, WEBP, HEIC or HEIF image.';
      }
      return '';
    }

    function petFiles(index) {
      if (!filesByPet[index]) filesByPet[index] = [];
      return filesByPet[index];
    }

    function removePreview(rec) {
      if (rec && rec.previewUrl) {
        try { URL.revokeObjectURL(rec.previewUrl); } catch (_) {}
      }
    }

    function renderPet(index) {
      var list = petFiles(index);
      var card = document.createElement('div');
      card.className = 'pgupl-v53__pet';
      card.setAttribute('data-pet-card', String(index));
      card.innerHTML =
        '<div class="pgupl-v53__pet-head">' +
          '<span class="pgupl-v53__pet-name"><span class="pgupl-v53__paw" aria-hidden="true">♡</span>Pet ' + index + '</span>' +
          '<span class="pgupl-v53__pet-count" data-count>' + list.length + ' / ' + maxPerPet + ' photos</span>' +
        '</div>' +
        '<p class="pgupl-v53__pet-hint">Upload up to 3 clear photos of this pet. We’ll select the best one.</p>' +
        '<button type="button" class="pgupl-v53__drop" data-pick>' +
          '<span class="pgupl-v53__upload-icon" aria-hidden="true">↑</span><span>Choose photos</span>' +
        '</button>' +
        '<input type="file" class="pgupl-v53__file-input" accept="image/*,.jpg,.jpeg,.png,.webp,.heic,.heif" multiple data-file-input>' +
        '<div class="pgupl-v53__thumbs" data-thumbs></div>';

      var picker = card.querySelector('[data-file-input]');
      var pick = card.querySelector('[data-pick]');
      var thumbs = card.querySelector('[data-thumbs]');
      var counter = card.querySelector('[data-count]');

      function refresh() {
        counter.textContent = list.length + ' / ' + maxPerPet + ' photos';
        pick.hidden = list.length >= maxPerPet;
        thumbs.innerHTML = '';
        list.forEach(function (rec, idx) {
          var item = document.createElement('div');
          item.className = 'pgupl-v53__thumb';
          var media = document.createElement('div');
          media.className = 'pgupl-v53__thumb-media';
          if (rec.previewUrl) {
            var img = document.createElement('img');
            img.alt = '';
            img.src = rec.previewUrl;
            media.appendChild(img);
          } else {
            media.textContent = 'Photo';
          }
          var meta = document.createElement('span');
          meta.className = 'pgupl-v53__thumb-name';
          meta.textContent = rec.file.name || ('Photo ' + (idx + 1));
          var remove = document.createElement('button');
          remove.type = 'button';
          remove.className = 'pgupl-v53__remove';
          remove.setAttribute('aria-label', 'Remove ' + (rec.file.name || 'photo'));
          remove.textContent = '×';
          remove.addEventListener('click', function () {
            if (busy) return;
            removePreview(rec);
            list.splice(idx, 1);
            refresh();
            setError('');
          });
          item.appendChild(media);
          item.appendChild(meta);
          item.appendChild(remove);
          thumbs.appendChild(item);
        });
      }

      pick.addEventListener('click', function () { if (!busy) picker.click(); });
      picker.addEventListener('change', function () {
        var incoming = Array.prototype.slice.call(picker.files || []);
        var room = Math.max(0, maxPerPet - list.length);
        picker.value = '';
        for (var i = 0; i < incoming.length && list.length < maxPerPet; i++) {
          var problem = fileValid(incoming[i]);
          if (problem) { setError(problem); continue; }
          var previewUrl = '';
          try { previewUrl = URL.createObjectURL(incoming[i]); } catch (_) {}
          list.push({ file: incoming[i], previewUrl: previewUrl });
        }
        if (incoming.length > room) {
          setError('You can upload up to 3 photos for each pet.');
        } else if (list.length) {
          setError('');
        }
        refresh();
      });

      refresh();
      return card;
    }

    function renderPets() {
      petsWrap.innerHTML = '';
      for (var i = 1; i <= petCount; i++) petsWrap.appendChild(renderPet(i));
    }

    function setPetCount(next) {
      if (busy) return;
      var n = Math.max(1, Math.min(maxPets, parseInt(next, 10) || 1));
      if (n < petCount) {
        for (var i = n + 1; i <= petCount; i++) {
          (filesByPet[i] || []).forEach(removePreview);
          delete filesByPet[i];
        }
      }
      petCount = n;
      pills.querySelectorAll('[data-pet-count]').forEach(function (button) {
        var active = parseInt(button.getAttribute('data-pet-count'), 10) === petCount;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      renderPets();
      setError('');
    }

    function allFiles() {
      var out = [];
      for (var pet = 1; pet <= petCount; pet++) {
        (filesByPet[pet] || []).forEach(function (rec, idx) {
          out.push({ pet: pet, photo: idx + 1, file: rec.file });
        });
      }
      return out;
    }

    function validate() {
      setError('');
      if (!orderInput.value.trim()) return 'Please enter your order number.';
      if (!emailInput.value.trim() || !emailInput.checkValidity()) return 'Please enter the email address used on the order.';
      for (var i = 1; i <= petCount; i++) {
        if (!(filesByPet[i] || []).length) return 'Please add at least one photo for Pet ' + i + '.';
      }
      return '';
    }

    function requestUpload(item, orderNumber, email, completed, total) {
      return new Promise(function (resolve, reject) {
        var data = new FormData();
        data.append('action', 'upload');
        data.append('order_number', orderNumber);
        data.append('email', email);
        data.append('submission_id', submissionId);
        data.append('pet_index', String(item.pet));
        data.append('photo_index', String(item.photo));
        data.append('file', item.file, item.file.name || ('pet-' + item.pet + '-photo-' + item.photo));

        var xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('X-PG-Upload', 'v1');
        xhr.responseType = 'json';
        xhr.upload.addEventListener('progress', function (event) {
          if (!event.lengthComputable || !event.total) return;
          var current = event.loaded / event.total;
          var overall = ((completed + current) / total) * 90;
          var pct = Math.max(1, Math.min(90, Math.round(overall)));
          setProgress(pct);
          setBusy(true, 'UPLOADING ' + pct + '%');
          setStatus('Uploading photo ' + (completed + 1) + ' of ' + total + '…');
        });
        xhr.addEventListener('load', function () {
          var body = xhr.response || {};
          if (xhr.status >= 200 && xhr.status < 300 && body.ok && body.asset_id) resolve(body);
          else reject(new Error(body.error || 'We couldn’t save that photo. Please try again.'));
        });
        xhr.addEventListener('error', function () { reject(new Error('The upload connection was interrupted. Please try again.')); });
        xhr.addEventListener('timeout', function () { reject(new Error('The upload took too long. Please try again.')); });
        xhr.timeout = 120000;
        xhr.send(data);
      });
    }

    function completeSubmission(orderNumber, email, assetIds) {
      setProgress(95);
      setBusy(true, 'FINISHING…');
      setStatus('Saving your photos against your order…');
      return fetch(endpoint, {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json', 'X-PG-Upload': 'v1' },
        body: JSON.stringify({
          action: 'complete',
          order_number: orderNumber,
          email: email,
          submission_id: submissionId,
          pet_count: petCount,
          notes: notesInput ? notesInput.value.trim() : '',
          asset_ids: assetIds
        })
      }).then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (body) {
          if (!response.ok || !body.ok) throw new Error(body.error || 'We couldn’t finish the submission. Please try again.');
          return body;
        });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (busy) return;
      var problem = validate();
      if (problem) {
        setError(problem);
        var target = error || form;
        if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var orderNumber = orderInput.value.trim();
      var email = emailInput.value.trim().toLowerCase();
      var queue = allFiles();
      var assetIds = [];
      var chain = Promise.resolve();

      setError('');
      setProgress(1);
      setBusy(true, 'UPLOADING 1%');
      setStatus('Preparing ' + queue.length + (queue.length === 1 ? ' photo' : ' photos') + '…');

      queue.forEach(function (item, index) {
        chain = chain.then(function () {
          return requestUpload(item, orderNumber, email, index, queue.length).then(function (result) {
            assetIds.push(result.asset_id);
            var pct = Math.round(((index + 1) / queue.length) * 90);
            setProgress(pct);
            setBusy(true, 'UPLOADING ' + pct + '%');
          });
        });
      });

      chain
        .then(function () { return completeSubmission(orderNumber, email, assetIds); })
        .then(function () {
          setProgress(100);
          setBusy(false);
          setStatus('');
          setError('');
          if (formBody) formBody.hidden = true;
          if (success) {
            success.hidden = false;
            success.setAttribute('tabindex', '-1');
            success.focus();
            success.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        })
        .catch(function (err) {
          setBusy(false);
          setProgress(0);
          setStatus('');
          setError(err && err.message ? err.message : 'We couldn’t save the upload just now. Please try again.');
          if (error && error.scrollIntoView) error.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    });

    pills.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-pet-count]');
      if (!button || busy) return;
      setPetCount(button.getAttribute('data-pet-count'));
    });

    setPetCount(1);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
